/**
 * O que o clique no polegar do Orby deve fazer, e o que a dica deve dizer.
 *
 * Mora fora do componente porque ele tem 1.592 linhas e nenhum teste. A regra
 * é pequena mas tem quatro casos, e três deles são invisíveis olhando a tela:
 * o revisado, a troca direta e o status ausente.
 */

export const REGISTRAR = 'registrar';
export const DESMARCAR = 'desmarcar';
export const BLOQUEADO = 'bloqueado';

/** Os status em que a equipe já mexeu -- ver `AiFeedbackController@review`. */
const JA_REVISADO = ['ok', 'reviewed', 'rejected'];

const foiRevisado = (atual) =>
    Boolean(atual && atual.status) && JA_REVISADO.includes(atual.status);

/**
 * @param {{rating: string, status?: string|null}|null|undefined} atual o feedback que já existe nesta resposta
 * @param {'like'|'dislike'} clicado o polegar em que a pessoa clicou
 * @returns {'registrar'|'desmarcar'|'bloqueado'}
 */
export const acaoDoFeedback = (atual, clicado) => {
    if (!atual || !atual.rating) {
        return REGISTRAR;
    }

    // Trocar direto um polegar pelo outro não é permitido: a reclamação exige
    // justificativa, e virar curtida com um clique abriria registro sem ela.
    if (atual.rating !== clicado) {
        return BLOQUEADO;
    }

    // Revisado carrega o trabalho de quem conferiu, e a api recusa com 409.
    // Bloquear aqui evita oferecer uma ação que vai falhar.
    if (foiRevisado(atual)) {
        return BLOQUEADO;
    }

    // Status ausente permite desmarcar: é o feedback recém-dado nesta sessão,
    // que nasce pendente. A api é a palavra final e recusa com mensagem se não
    // estiver. Bloquear por falta de informação impediria exatamente o
    // desmarcar logo após o clique por engano, que é o caso mais comum.
    return DESMARCAR;
};

/**
 * @param {{rating: string, status?: string|null}|null|undefined} atual
 * @param {'like'|'dislike'} polegar
 * @returns {string}
 */
export const dicaDoPolegar = (atual, polegar) => {
    const acao = acaoDoFeedback(atual, polegar);

    if (acao === REGISTRAR) {
        return polegar === 'like' ? 'Resposta útil' : 'Resposta não ajudou';
    }

    if (acao === DESMARCAR) {
        return polegar === 'like'
            ? 'Você marcou como útil — clique para desmarcar'
            : 'Você marcou como não útil — clique para desmarcar';
    }

    if (foiRevisado(atual)) {
        return 'A equipe já revisou este feedback';
    }

    return 'Desmarque a outra opção primeiro';
};
